export const CERTIFIED_THRESHOLD = 90
